<template>
  <Modal @close="$emit('close')">
    <template slot="body">
      <div>
        <div class="d-flex flex-column text-center">
          <span
            v-if="gameType !== 'summer'"
            :class="$style.rankText"
          >
            {{ $t('RANK-X', { rank: Math.abs(currentScore - 9)}) }}
          </span>
          <span :class="$style.playersOverviewText">
            {{ $t('PLAYERS-OVERVIEW') }}
          </span>
          <span
            v-if="currentPosition.users.length"
            :class="$style.scoreText"
          >
            {{ $t('score') }}: {{ currentPosition.users[0].score }}
          </span>
        </div>
        <ThePositionPlayersOverview
          :position="currentPosition"
        />
        <div
          v-if="totalPlayers - currentPosition.users.length > 0"
          class="d-flex justify-content-center pb-4"
        >
          {{ $tc('and-x-more-player', totalPlayers - currentPosition.users.length, {
            count: totalPlayers - currentPosition.users.length
          }) }}
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import ThePositionPlayersOverview from '@/pages/CurrentStandings/Components/ThePositionPlayersOverview'
import Modal from '@/components/Molecules/Modal'

export default {
  name: 'TheRankOverviewModal',
  components: { Modal, ThePositionPlayersOverview },
  props: {
    currentPosition: {
      type: Object,
      required: true,
    },
    currentScore: {
      type: Number,
      required: true,
    },
    totalPlayers: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      gameType: state => state['game/type'].type,
    }),
  },
}
</script>

<style lang="scss" module>
  @import "../../assets/scss/variables";
  .rankText {
    font-size: $font-size-xlarge;
    font-weight: 600;
  }
  .playersOverviewText {
    font-size: $font-size-xxlarge;
    font-weight: 600;
  }
  .scoreText {
    font-size: $font-size-xlarge;
  }
</style>
